import { AnswerResult } from "../../../../store/viewmodels/AnswerViewModel";
import { getDurationInSeconds } from "../../../utils/DateServices";

interface OneChoiceResultItemProps {
    answer: AnswerResult,
}

function OneChoiceResultItem(props: OneChoiceResultItemProps): JSX.Element {
    const endDate = new Date(Date.parse(props.answer.end_time));
    const startDate = new Date(Date.parse(props.answer.start_time));
    const durationSeconds = getDurationInSeconds(endDate, startDate);

    const symbol = props.answer.value === props.answer.item.correct ?
        <span className="ri-check-line text-green-500 font-bold ml-8 my-auto" key={"symbol-" + props.answer.id}></span> :
        <span className="ri-close-line text-red-500 font-bold ml-8 my-auto" key={"symbol-" + props.answer.id}></span>

    return (
        <div className="grid grid-cols-6 mt-1 border-b border-gray-100">
            <span className="col-span-2 my-auto" key={"question-" + props.answer.id}>{props.answer.item.content}</span>
            <span className="ml-5 my-auto" key={"answer-" + props.answer.id}>{props.answer.value}</span>
            <span className="ml-5 my-auto" key={"correct-" + props.answer.id}>{props.answer.item.correct}</span>
            {symbol}
            <span className="ml-5 my-auto" key={"correct_wrong-" + props.answer.id}>{durationSeconds + " s"}</span>
        </div>
    );
}

export default OneChoiceResultItem;